import axios from 'axios';
import { get } from 'js-cookie';

class MembershipApiService {
  static async sendEmailVerification(): Promise<void> {
    return axios.post(
      `${process.env.REACT_APP_MEMBERSHIP_API_HOST}/members/email_verification`,
      { destination_url: window.location.href },
      {
        headers: {
          'membership-session-token': get('xo-session-token') as string,
          'X-API-KEY': process.env.REACT_APP_GLM_UNION_MEMBERSHIP_API_KEY as string,
        },
      }
    );
  }
}

export default MembershipApiService;
